module.exports = {"data":{"site":{"siteMetadata":{"title":"AI Gender Bias Education Program"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 101
// module chunks = 60335399758886 114276838955818